import React, { useState } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AddIcon from '@mui/icons-material/Add';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from 'react-router-dom';
import Path from '../../Common/Path';
import Slider from 'react-slick';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import MaterialData from '../../Common/MaterialData';

const imageData = [
  {
    image: "./assets/Slider/slider1.jpg",
    tagline: "Transforming Spaces with Durable PVC Excellence!",
    note: "Experience the Future of Furniture with Zeaco PVC Profiles!"
  },
  {
    image: "./assets/Slider/slider2.png",
    tagline: "Elegant, Eco-friendly & Everlasting PVC Furniture",
    note: "Strength Meets Style – Perfect PVC Solutions for Every Space!"
  },
  {
    image: "./assets/Slider/slider-3.jpg",
    tagline: "Innovation in Every PVC Profile!",
    note: "Waterproof, Termite-Proof & Maintenance-Free – The Zeaco PVC Promise!"
  },
  {
    image: "./assets/Slider/slider-4.jpg",
    tagline: "Crafted for Style, Built to Last!",
    note: "Upgrade Your Interiors with Sustainable & Stylish PVC Furniture!"
  },
  {
    image: "./assets/Slider/slider5.jpg",
    tagline: "Smart Living with Premium PVC Solutions!",
    note: "Custom Designs, Maximum Durability – Choose Zeaco PVC!"
  }
];

const homeProduct = [
  {
    id: 1,
    title: "uPVC Doors",
    navigate: Path.doors,
    imgSrc: "./assets/home-door.jpg",
  },
  {
    id: 2,
    title: "Kitchen Cabinet Furniture",
    navigate: Path.furniture_kitchen,
    imgSrc: "./assets/home-kitchen.jpg",
  },
  {
    id: 3,
    title: "uPVC Cabinet",
    navigate: Path.furniture_cabinet,
    imgSrc: "./assets/home-cabinet.jpg",
  },
  {
    id: 4,
    title: "WPC Furniture",
    navigate: Path.furniture,
    imgSrc: "./assets/home-office.jpg",
  },
]

const keyFeatures = [
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/termite_proof.svg",
    title: "Termite Proof",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/fast_installation.svg",
    title: "Fast Installation",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/fire_retardant.svg",
    title: "Fire Retardant",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/extra_highly_uv_resistant.svg",
    title: "Extra Highly UV Resistant",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/lead_free.svg",
    title: "100% Lead Free",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/maintenance_free.svg",
    title: "Maintenance Free",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/impact_resistance.svg",
    title: "Impact Resistance",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/water_proof.svg",
    title: "100% Water Proof",
  },
  {
    img: "https://www.kakaprofile.com/wp-content/uploads/2022/09/insulation_properties.svg",
    title: "Insulation Properties",
  },
]

const HomeImages = [
  "./assets/HomeImage/homeimage1.jpg",
  "./assets/HomeImage/homeimage2.jpg",
  "./assets/HomeImage/homeimage3.jpg",
  "./assets/HomeImage/homeimage4.jpg",
  "./assets/HomeImage/homeimage5.jpg",
  "./assets/HomeImage/homeimage6.jpg",
  "./assets/HomeImage/homeimage7.jpg",
  "./assets/HomeImage/homeimage8.jpg",
  "./assets/HomeImage/homeimage9.jpg",
  "./assets/HomeImage/homeimage10.jpg",
]

const Material_Data = [...MaterialData.data]
export default function HomeScreen() {
  const navigate = useNavigate()
  const [activeIndex, setActiveIndex] = useState(0);
  const [materialData, setmaterialData] = useState(Material_Data.filter((x) => x.category.split("_")[1] === "home"))
  console.log(materialData);

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };


  const [hoveredCard, setHoveredCard] = useState(null);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true, // Default for larger screens
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false, // Hide arrows on tablets
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false, // Hide arrows on mobile
        },
      },
    ],
  };



  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <FaChevronLeft
        className={className}
        style={{ ...style, color: "green", fontSize: "32px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <FaChevronRight
        className={className}
        style={{ ...style, color: "green", fontSize: "32px", zIndex: 1 }}
        onClick={onClick}
      />
    );
  };

  const slider2Settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true, // Default for larger screens
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false, // Hide arrows on tablets
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false, // Hide arrows on mobile
        },
      },
    ],
  };


  return (
    <div className='HomeScreen'>
      <div id="carouselExample" className="carousel slide position-relative">
        <div className="carousel-inner">
          {imageData.map((item, index) => (
            <div
              key={index}
              className={`carousel-item ${index === activeIndex ? "active" : ""}`}
            >
              <img src={item.image} className="d-block w-100" alt="Slide" height="500px" />

              {/* Overlay Content */}
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
                <div style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }} className="p-2 rounded-3">
                  <h1 className="fw-bold text-light px-3 py-1 rounded">{item.tagline}</h1>
                  <h4 className="text-light px-2 py-1 rounded">{item.note}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <button
          className="carousel-control-prev"
          type="button"
          onClick={() =>
            setActiveIndex((prevIndex) => (prevIndex - 1 + imageData.length) % imageData.length)
          }
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          onClick={() =>
            setActiveIndex((prevIndex) => (prevIndex + 1) % imageData.length)
          }
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>

        {/* Thumbnail Navigation */}
        <div className="navigate position-absolute bottom-0 w-100">
          <div className="row d-flex justify-content-center">
            {imageData.map((item, index) => (
              <div
                key={index}
                className="col-lg-1 col-2"
                onClick={() => handleThumbnailClick(index)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={item.image}
                  className="d-block"
                  alt="Thumbnail"
                  width="100%"
                  height="50px"
                  style={{
                    border: index === activeIndex ? "4px solid darkgreen" : "4px solid grey",
                    borderRadius: "5px",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="section"></div>
      <div className="container">
        <div className="row d-flex align-items-center">
          <div className="col-12 col-md-6">
            <div className="h1 text_main text-start">Zeaco PVC Profile </div>
            <div className="h4 text-muted text-start">Crafting Durable, Stylish & Sustainable Spaces!</div>
            <p style={{ textAlign: "justify" }} className=''>Welcome to Zeaco PVC Profile, where innovation meets durability in PVC furniture solutions! We specialize in high-quality, eco-friendly, and long-lasting PVC profiles, designed to transform your interiors with elegance and strength. Our products are termite-proof, waterproof, and maintenance-free, making them the perfect choice for modern homes and commercial spaces. At Zeaco, we believe in delivering excellence through cutting-edge technology and superior craftsmanship. Explore our range of premium PVC solutions and redefine your living spaces with style and sustainability!</p>
          </div>
          <div className="col-12 col-md-6">
            <div className="d-flex p-3">
              <img src="./assets/Home_abt.png" alt="" width={"80%"} />
            </div>
          </div>
        </div>
      </div>
      <div className="section"></div>
      <div className="container">
        <div className="h1 text_main text-center">Our Popular Categories</div>
        <div className="text-center text-muted h5">Explore Our Bestselling PVC Creations – Style, Strength & Sustainability!</div>
        <div className="row">
          {homeProduct.map((product) => (
            <div key={product.id} className="col-12 col-md-6 my-3">
              <div
                className="pro_card"
                onMouseEnter={() => setHoveredCard(product.id)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{
                  position: "relative",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
                onClick={() => navigate(product.navigate)}
              >
                <div className="img">
                  <img src={product.imgSrc} alt={product.title} width={"100%"} height={"400px"} />
                </div>
                <div className="pro_back"></div>
                <div className="pro_detail w-100">
                  <div className="d-flex justify-content-between align-items-center text_secound mx-3">
                    <div className="h2" style={{ color: "white" }}>
                      {product.title}
                    </div>
                    <div className="d-flex">
                      {hoveredCard === product.id ? (
                        <ArrowForwardIcon style={{ fontSize: "50px", color: "rgb(4, 150, 63)" }} />
                      ) : (
                        <AddIcon style={{ fontSize: "50px", color: "white" }} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="section"></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center h2 text_main">Key Features of</div>
            <div className="text-center h5 text-muted">Zeaco Industries Door and UPVC Window</div>
          </div>
          <div className="col-12 my-4">
            <Slider {...sliderSettings}>
              {keyFeatures.map((slide, index) => (
                <div className="feature p-3" key={index}>
                  <div className="d-flex justify-content-center">
                    <img src={slide.img} alt="" />
                  </div>
                  <div className="text-center">
                    {slide.title}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      <div className="section"></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center h2 text_main">Our Furniture Work</div>
            <div className="text-center h5 text-muted">Zeaco Crafting Excellence, Shaping Comfort!</div>
          </div>

          <Slider {...slider2Settings}>
            {HomeImages.map((slide, index) => (
              <div className="col-12 my-4">
                <div className="feature p-3" key={index}>
                  <div className="d-flex justify-content-center">
                    <img src={slide} alt="" width={"100%"} height={"200px"} />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className="section"></div>
      <div className="">
        <div className="container gallery">
          <div className="text-center h2 text_main mb-3">Our Product TimeLine</div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-12 col-md-4 xl">
                  <div onClick={() => navigate(Path.doors)} className="d-flex h-100 justify-content-center">
                    <img src="/assets/doors/door5.jpg" alt="" width={"100%"} height={"360px"} />
                  </div>
                </div>
                <div className="col-12 col-md-8">
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-12 col-md-5 md">
                          <div className="d-flex h-100 justify-content-center">
                            <img src="/assets/cabinate/cabinate3.jpg" alt="" width={"100%"} height={"100%"} />
                          </div>
                        </div>
                        <div className="col-12 col-md-7 md">
                          <div className="d-flex h-100 justify-content-center">
                            <img src="/assets/office/office5.jpg" alt="" width={"100%"} height={"100%"} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 md">
                      <div className="d-flex h-100 justify-content-center">
                        <img src="/assets/kitchen/kitchen1.jpg" alt="" width={"100%"} height={"100%"} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 md">
                      <div className="d-flex h-100 justify-content-center">
                        <img src="/assets/office/office1.jpg" alt="" width={"100%"} height={"100%"} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-12 col-md-5 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/kitchen/kitchen4.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
                <div className="col-12 col-md-7 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/drawingrooms/drawingroom4.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
                <div className="col-12 col-md-7 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="./Logo.png" alt="" />
                  </div>
                </div>
                <div className="col-12 col-md-5 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/office/office2.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-7">
              <div className="row">
                <div className="col-12 col-md-4 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/office/office4.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
                <div className="col-12 col-md-5 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/drawingrooms/drawingroom3.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
                <div className="col-12 col-md-3 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/cabinate/cabinate5.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
                <div className="col-12 col-md-3 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/cabinate/cabinate4.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
                <div className="col-12 col-md-4 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/kitchen/kitchen3.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
                <div className="col-12 col-md-5 md">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/office/office3.jpg" alt="" width={"100%"} height={"100%"} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-5">
              <div className="row">
                <div className="col-12 col-md-8">
                  <div className="row">
                    <div className="col-12 md">
                      <div className="d-flex h-100 justify-content-center">
                        <img src="/assets/drawingrooms/drawingroom1.jpg" alt="" width={"100%"} height={"100%"} />
                      </div>
                    </div>
                    <div className="col-12 md">
                      <div className="d-flex h-100 justify-content-center">
                        <img src="/assets/drawingrooms/drawingroom5.jpg" alt="" width={"100%"} height={"100%"} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4 xl">
                  <div className="d-flex h-100 justify-content-center">
                    <img src="/assets/doors/door6.jpg" alt="" width={"100%"} height={"360px"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="container">
          <div className="text-center h2 text_main mb-3">Material Section</div>
          <div className="row">
            {
              materialData && materialData.map((data) => {
                return <div className="col-6 col-md-3 my-2">
                  <div className="card">
                    <div className="card_img">
                      <img src={data.img} alt="asdfa" width="100%" height={"450px"} />
                    </div>
                    <div className="p-2">
                      <div className="h5">{data.title}</div>
                      <div className="h6">{data.color}</div>
                    </div>
                  </div>
                </div>
              })
            }
            <div className="col-6 col-md-3 my-2">
              <div className="d-flex justify-content-center align-items-center h-100">
                <div className="btn btn_outline" onClick={() => navigate(Path.material)} >Explore More...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section"></div>
      <div className="home_contact d-flex flex-column flex-md-row align-items-center justify-content-md-around justify-content-center">
        <div className="">
          <div className="h1 text-white">Speak To Our Expert & Consultant</div>
          <div className="h4 text-white"> If you have some query or looking for some quote from our side just feel free to connect with us</div>
        </div>
        <div className="">
          <div onClick={() => navigate(Path.contact)} className="btn btn-light">Contact Us</div>
        </div>
      </div>

    </div>
  )
}
